import axios from 'axios';
import { n8nBaseURL } from './config';

const client = axios.create({
  baseURL: n8nBaseURL,
  headers: {
    'Content-Type': 'application/json',
  },
});

client.interceptors.request.use(async (config) => {
  const accessToken = localStorage.getItem('session');
  if (accessToken && !config.skipAuth) {
    config.headers = {
      ...config.headers,
      Authorization: `Bearer ${accessToken}`,
    };
  }
  return config;
});

client.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('N8n API Error:', error);
    return Promise.reject(error);
  }
);

export const n8nClient = client;
